module.exports = __webpack_public_path__ + "static/img/2.e0f482a.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/2.png
// module id = 8mSV
// module chunks = 9